import { useEffect } from 'react';

import { Outlet, useLocation } from 'react-router';

import { Box, IconButton, Tooltip } from '@mui/material';
import ReactGA from 'react-ga4';
import { BsWhatsapp } from 'react-icons/bs';

import { CardBanner } from 'components/banner';
import { ComunicadoModal, DreModal, GradeModal } from 'components/modal';
import { Footer, Header } from 'components/page';
import { useApplicationContext } from 'context/ApplicationContext';
import { useClientContext } from 'context/ClientContext';
import { PopupProvider } from 'context/PopupContext';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { useQueryWhatsApp } from 'hooks/useQueryWhatsApp';
import { useTitle } from 'hooks/useTitle';

export function Layout() {
    const { user, store } = useApplicationContext();
    const { documentTitle, googleAnalyticsTrackingId } = useClientContext();
    const location = useLocation();
    const { isUpMd } = useBreakpoints();
    const { data: link } = useQueryWhatsApp();
    const showWhatsAppFooter = isUpMd && link;

    /**
     * Seta o título da página.
     */
    useTitle({ documentTitle });

    /**
     * Envia métricas para o Google Analytics.
     */
    useEffect(() => {
        if (user.tipoUsuario.tipoUsuarioEnum === 'FRANQUEADO' && googleAnalyticsTrackingId && import.meta.env.PROD) {
            ReactGA.initialize(googleAnalyticsTrackingId);

            ReactGA.set({ dimension1: store.dsNomeFantasia });
            ReactGA.set({ dimension2: user.idUsuario.toString() });
            ReactGA.set({ metric1: store.idLoja });
            ReactGA.set({ metric2: user.idUsuario });
        }
    }, [location, googleAnalyticsTrackingId, user, store]);

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100dvh',
                    width: '100%',
                    backgroundColor: (theme) => theme.palette.grey[100],
                }}
            >
                <Header />

                <CardBanner />

                <Outlet />

                <PopupProvider>
                    <ComunicadoModal />

                    <GradeModal />

                    <DreModal />
                </PopupProvider>

                {isUpMd && <Footer />}
            </Box>

            {showWhatsAppFooter && (
                <Tooltip title="Fale com o Customer" placement="right" arrow>
                    <IconButton
                        onClick={() => window.open(link, '_blank')}
                        sx={{
                            'padding': 1.5,
                            'backgroundColor': '#25D366',
                            'color': '#fff',
                            ':hover': { backgroundColor: '#1cbf58' },
                            'zIndex': 11,
                            'position': 'fixed',
                            'bottom': window.innerWidth > 1500 ? 16 : 62,
                            'left': 16,
                        }}
                    >
                        <BsWhatsapp />
                    </IconButton>
                </Tooltip>
            )}
        </>
    );
}
